<template>
  <div class="center-screen">
    <div class="container align-justify-center">
      <div class="auth-form login">
          <div class="row">
            <div class="col" style="justify-content: center;">
                <h4 style="text-align:center" v-if="message">{{$t(message)}}</h4>
                <h4 style="text-align:center" v-else>
                    <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                      <path fill="#fff" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                        <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform>
                      </path>
                    </svg>
                    Lütfen Bekleyiniz...
                </h4>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name: 'EmailVerify',
    metaInfo () {
        return {
        title: 'Email Verify | ' + _.get(this.$store.getters['getClientMeta'], 'main.title', ''),
        }
    },
    data(){
      return{
        token: this.$route.query.token,
        isLoading: false,
        message: null
      }
    },
    mounted(){
      if(this.token)
      {
        this.updatePassword();
      }
    },
    methods:{
      updatePassword(){
        this.isLoading = true;
        axios.patch('/auth/email/verify', { token: this.token })
            .then((response)=>{
              this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
              this.message = response.data.message
          })
          .catch((err)=>{
              this.message = err.response.data.message
          })
          .finally((f) => { 
              this.isLoading = false;
          })
      },
    },
  }
</script>


<style scoped lang="scss">
  h4{
    display: flex;
    align-items: center;
    svg{
      width: 30px;
      height: 30px;
    }
  }
</style>